import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useState } from 'react';

const Formulir = () => {
  const [currentId, setCurrentId] = useState(-1);
  const [fetchStatus, setFetchStatus] = useState(true);
  let [dataLowongan, setDataLowongan] = useState([]);

  const [input, setInput] = useState({
    title: '',
    job_description: '',
    job_qualification: '',
    job_type: '',
    job_tenure: '',
    job_status: 0,
    company_name: '',
    company_image_url: '',
    company_city: '',
    salary_min: 0,
    salary_max: 0,
  });

  const handleChange = (event) => {
    let { name, value } = event.target;
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let {
      title,
      job_description,
      job_qualification,
      job_type,
      job_tenure,
      job_status,
      company_name,
      company_image_url,
      company_city,
      salary_min,
      salary_max,
    } = input;

    if (currentId === -1) {
      axios
        .post(
          `https://dev-example.sanbercloud.com/api/job-vacancy`,
          {
            title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            job_status,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max,
          },
          {
            headers: { Authorization: 'Bearer ' + Cookies.get('token') },
          }
        )
        .then(({ data }) => {
          setFetchStatus(true);
        })
        .catch((err) => {});
    } else {
      axios
        .put(
          `https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`,
          {
            title: input.title,
            job_description: input.job_description,
            job_qualification: input.job_qualification,
            job_type: input.job_type,
            job_tenure: input.job_tenure,
            job_status: input.job_status,
            company_name: input.company_name,
            company_image_url: input.company_image_url,
            company_city: input.company_city,
            salary_min: input.salary_min,
            salary_max: input.salary_max,
          },
          {
            headers: { Authorization: 'Bearer ' + Cookies.get('token') },
          }
        )
        .then((res) => {
          setFetchStatus(true);
          let data = dataLowongan.find((el) => el.id === currentId);
          title = data.title;
          job_description = data.job_description;
          job_qualification = data.job_qualification;
          job_type = data.job_type;
          job_tenure = data.job_tenure;
          job_status = data.job_status;
          company_name = data.company_name;
          company_image_url = data.company_image_url;
          company_city = data.company_city;
          salary_min = data.salary_min;
          salary_max = data.salary_max;
          setDataLowongan([...dataLowongan]);
        });
    }

    setInput({
      title: '',
      job_description: '',
      job_qualification: '',
      job_type: '',
      job_tenure: '',
      job_status: 0,
      company_name: '',
      company_image_url: '',
      company_city: '',
      salary_min: 0,
      salary_max: 0,
    });

    setCurrentId(-1);
  };

  console.log(setDataLowongan);

  return (
    <>
      <div className="container flex w-full m-auto">
        <form
          onSubmit={handleSubmit}
          className="w-3/4 m-auto bg-white border rounded-lg shadow-2xl"
        >
          <div className="px-4 py-8 sm:px-10">
            <div className="relative mt-6">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm leading-5">
                <span className="px-2 text-xl font-semibold text-gray-400 bg-white">
                  Formulir Input Data
                </span>
              </div>
            </div>
            <div className="mt-14">
              <div className="grid w-full space-y-6 gap-y-6">
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.title}
                      onChange={handleChange}
                      name="title"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Title"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_description}
                      onChange={handleChange}
                      name="job_description"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Description"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_qualification}
                      onChange={handleChange}
                      name="job_qualification"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Qualification"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_type}
                      onChange={handleChange}
                      name="job_type"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Type"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_tenure}
                      onChange={handleChange}
                      name="job_tenure"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Tenure"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_status}
                      onChange={handleChange}
                      name="job_status"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Status"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.company_name}
                      onChange={handleChange}
                      name="company_name"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Company Name"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.company_image_url}
                      onChange={handleChange}
                      name="company_image_url"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Company Image Url"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.company_city}
                      onChange={handleChange}
                      name="company_city"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Company City"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.salary_min}
                      onChange={handleChange}
                      name="salary_min"
                      type="number"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Salary Min"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.salary_max}
                      onChange={handleChange}
                      name="salary_max"
                      type="number"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Salary Max"
                    />
                  </div>
                </div>
                <div>
                  <span className="block w-full mb-10 rounded-md shadow-sm">
                    <button
                      type="submit"
                      className="w-full px-4 py-2 text-base font-semibold text-center text-white transition duration-200 ease-in bg-blue-500 rounded-lg shadow-md hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 "
                    >
                      Kirim
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Formulir;
